"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.custom = void 0;
const node_util_1 = require("node:util");
exports.custom = node_util_1.inspect.custom;
//# sourceMappingURL=inspect.js.map